import React, { useState } from "react";
import Swal from "sweetalert2";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./PrivacyPolicy.css";
import CONFIG from "../src/config";
import axios from "axios";

function UserDeleteRequest() {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const validateEmail = (email) => {
    const emailPattern =
      /^[\w.-]+@(gmail\.com|yahoo\.com|cogniitec\.com|outlook\.com|hotmail\.com|icloud\.com|protonmail\.com|aol\.com)$/;
    return emailPattern.test(email);
  };

  const handleValidation = () => {
    let formErrors = {};
    let isValid = true;

    if (!email) {
      formErrors.email = "Email is required";
      isValid = false;
    } else if (!validateEmail(email)) {
      formErrors.email =
        "Please enter a valid email address (e.g., user@gmail.com)";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleClick = async () => {
    if (!handleValidation()) {
      return;
    }

    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Are you sure that you want to delete this account?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#e53e3e",
      cancelButtonColor: "#2b6cb0",
      reverseButtons: true,
      focusCancel: true,
      customClass: {
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
    });

    if (result.isConfirmed) {
      try {
        const response = await fetch(
          `https://www.hrmsapi.ktig.org.in/api/del-request`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ employee_email: email }),
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.message || "Failed to submit request");
        }

        toast.success(data.message || "Request submitted successfully!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setEmail("");
        setErrors({});
      } catch (error) {
        toast.error(error.message || "Error submitting delete request!", {
          position: "top-right",
          autoClose: 3000,
        });
      }
    }
  };

  return (
    <div className="privacy-container">
      <ToastContainer />

      <header className="privacy-header">
        <h1>Data Deletion Request</h1>
        <div className="app-info">
          <span className="app-name">KTIG HRMS Attendance</span>
          <span className="developer">by BNR Cogniitec Private Limited</span>
        </div>
      </header>

      <div className="content-wrapper">
        <section className="privacy-section">
          <div className="section-icon">🔐</div>
          <div className="section-content">
            <h2>Your Privacy Matters</h2>
            <p>
              We are committed to protecting your data and providing
              transparency about how it's used and deleted.
            </p>
          </div>
        </section>

        <section className="privacy-section">
          <div className="section-icon">📝</div>
          <div className="section-content">
            <h2>Request Account Deletion</h2>
            <p>Enter your registered email to delete your account:</p>
            <div className="email-input-group">
              <input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`email-input ${errors.email ? "input-error" : ""}`}
              />
              {errors.email && (
                <div className="text-danger">{errors.email}</div>
              )}
              <button onClick={handleClick} className="delete-button">
                Delete Account
              </button>
            </div>
          </div>
        </section>

        <section className="privacy-section">
          <div className="section-icon">🗃️</div>
          <div className="section-content">
            <h2>What Data Will Be Deleted?</h2>
            <ul className="data-list">
              <li>Name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Employee ID and profile</li>
              <li>Attendance and leave records</li>
              <li>Any associated employment data</li>
            </ul>
          </div>
        </section>

        <section className="privacy-section">
          <div className="section-icon">⏳</div>
          <div className="section-content">
            <h2>Data Retention Policy</h2>
            <ul className="retention-list">
              <li>
                <strong>30 days</strong> after an employee's relieving date
              </li>
              <li>
                <strong>30 days</strong> after a user submits a delete request
              </li>
            </ul>
            <p>
              After this period, your data is permanently removed from our
              systems.
            </p>
          </div>
        </section>

        <section className="privacy-section contact-section">
          <div className="section-icon">💬</div>
          <div className="section-content">
            <h2>Need Help?</h2>
            <p>If you have any concerns or questions, please contact us:</p>
            <a href="mailto:info@ktig.co.in" className="contact-email">
              info@ktig.co.in
            </a>
          </div>
        </section>
      </div>
    </div>
  );
}

export default UserDeleteRequest;
